<template>
<!--客户logo-->
  <div class="zj_customerLogo">
    <div class="title1 flexcc font16rem black wow bounceIn" 
      data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1">{{$t('强大的技术实力，持续引领市场')}}</div>
    <div class="title2 flexcc font10rem black wow bounceIn" 
      data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1">{{$t('十六年的经验积累，产品精打细磨，客户口碑相传')}}</div>
    <div class="customerLogo">
      <div class="logo flexcc wow" v-for="item in logodata" :key="item.index" :class="item.index<=6||item.index>=13?'bounceInLeft':'bounceInRight'"
        data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1">
        <img :src="item.pic" />
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import Swiper from "swiper";
export default {
  name: "zj_customerLogo",
  data() {
    return {
      logodata: [
        {
          index: 1,
          name: "anta",
          pic: require("../assets/Images/brand/anta.png"),
        },
        {
          index: 2,
          name: "太平鸟",
          pic: require("../assets/Images/brand/peacebird.png"),
        },
        {
          index: 3,
          name: "波司登",
          pic: require("../assets/Images/brand/bsd.png"),
        },
        {
          index: 19,
          name: "晨光",
          pic: require("../assets/Images/brand/cg.png"),
        },
        {
          index: 19,
          name: "森马",
          pic: require("../assets/Images/brand/sm1.svg"),
        },
        {
          index: 16,
          name: "amersports",
          pic: require("../assets/Images/brand/amersports.png"),
        },
        {
          index: 6,
          name: "雅诗兰黛",
          pic: require("../assets/Images/brand/EsteeLauder.png"),
        },
        {
          index: 16,
          name: "海棠铺子",
          pic: require("../assets/Images/brand/htpz.png"),
        },
        {
          index: 6,
          name: "戎美",
          pic: require("../assets/Images/brand/rm1.jpg"),
        },
        //
        // {
        //   index: 8,
        //   name: "delicates",
        //   pic: require("../assets/Images/brand/delicates.png"),
        // },
        // {
        //   index: 9,
        //   name: "suunto",
        //   pic: require("../assets/Images/brand/suunto.png"),
        // },
        // {
        //   index: 14,
        //   name: "小笑牛",
        //   pic: require("../assets/Images/brand/kingkow.png"),
        // },
        // {
        //   index: 17,
        //   name: "precor",
        //   pic: require("../assets/Images/brand/precor.png"),
        // },
        // {
        //   index: 18,
        //   name: "atomic",
        //   pic: require("../assets/Images/brand/atomic.png"),
        // },
        {
          index: 4,
          name: "fila",
          pic: require("../assets/Images/brand/fila.png"),
        },
        {
          index: 5,
          name: "绿叶",
          pic: require("../assets/Images/brand/ly.png"),
        },
        {
          index: 7,
          name: "木槿",
          pic: require("../assets/Images/brand/mumuso.png"),
        },
        {
          index: 8,
          name: "九木",
          pic: require("../assets/Images/brand/jm.png"),
        },
        {
          index: 10,
          name: "outdoor",
          pic: require("../assets/Images/brand/outdoor.png"),
        },
        {
          index: 11,
          name: "热风",
          pic: require("../assets/Images/brand/hotwind.png"),
        },
        {
          index: 12,
          name: "wilson",
          pic: require("../assets/Images/brand/wilson.png"),
        },
        {
          index: 13,
          name: "可隆",
          pic: require("../assets/Images/brand/kolon.png"),
        },
        {
          index: 15,
          name: "迪桑特",
          pic: require("../assets/Images/brand/descente.png"),
        },
      ],
    };
  },
  watch: {},
  mounted() {
    new this.$wow.WOW({ live: false }).init();
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.zj_customerLogo {
  width: 100%;
  height: 100%;
  .title1{
    width: 100%;
  height: 4rem;
  }
  .title2{
    width: 100%;
  height:2rem;
  }
  .customerLogo{
    width: 70%;
  height: 30rem;
  margin-left: 17%;
  .logo{
    width: 14%;
    height: 7rem;
    box-shadow: 0 0 10px rgba(85, 85, 85, 0.2);
    float: left;
    margin: 2% 2.5% 0 0;
    img{
      width: 70%;
    }
  }
  }
}
</style>
